import { render, staticRenderFns } from "./IdeasoftIcon.vue?vue&type=template&id=5842adc8&scoped=true"
import script from "./IdeasoftIcon.vue?vue&type=script&lang=js"
export * from "./IdeasoftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842adc8",
  null
  
)

export default component.exports